module.exports = __webpack_public_path__ + "static/media/chevron-up.8770b3ed.svg";